import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const getGameLink = createAsyncThunk(
  "getGameLink",
  async (payload, thunkAPI) => {
    try {
      
      const response = await api.post("dream_casino/get-game-link", JSON.stringify(payload));
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);

const getGameLinkSlice = createSlice({
  name: "getGameLink",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getGameLink.pending, (state) => {
        state.loading = true;
      })
      .addCase(getGameLink.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getGameLink.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default getGameLinkSlice.reducer;
